import React from "react";
import frontend from "./frontend.png";
import backend from "./backend.png";
import fullstack from "./fullstack.png";
import "./aboutMe.css";
export default function AboutMe() {
  return (
    <>
      <div className="aboutContainer">
        <div className="aboutTitle">
          <h1>About Me</h1>
          <div>
            <hr />
          </div>
        </div>
        <div className="aboutDetails">
          <span className="about-intro">
            Hi there! I'm Ahmed Sayed, a passionate Full Stack Python/React
            Developer dedicated to creating stunning web applications.
          </span>
          <p>
            Offering free maintenance and support services even after project
            completion, I ensure your satisfaction and value. My problem-solving
            skills and proficiency in both front-end and back-end development
            using various technologies guarantee high-quality solutions.
            Dedicated to self-improvement, I strive to enhance my skills every
            day to deliver better results. Committed to customer satisfaction
            and market standards.
          </p>
        </div>
        <h2>What I Do</h2>
        <div className="WIDSection">
          <div className="WIDItem">
            <div className="WIDItemHeader">
              <div className="WIDicon">
                <img src={frontend} alt="frontend" />
              </div>
              <div className="WIDDetails">
                <h3>Frontend Web Development</h3>
              </div>
            </div>
            <div className="WIDPoints">
              <span>
                Craft engaging React UIs with responsive design and intuitive
                user experiences.
              </span>
              <hr />
              <span>
                Translating designs into dynamic frontend experiences with React
              </span>
              <hr />
              <span>
                Ensuring cross-browser compatibility and accessibility for
                seamless user interaction
              </span>
            </div>
          </div>
          <div className="WIDItem">
            <div className="WIDItemHeader">
              <div className="WIDicon">
                <img src={backend} alt="backend" />
              </div>
              <div className="WIDDetails">
                <h3>Backend Web Development</h3>
              </div>
            </div>
            <div className="WIDPoints">
              <span>
                Ensure data integrity and security through efficient database
                design and RESTful APIs.
              </span>
              <hr />
              <span>
                Implement complex business logic, authentication mechanisms, and
                scalable infrastructure.
              </span>
              <hr />
              <span>
                Craft efficient backend solutions that power dynamic and
                responsive web experiences.
              </span>
            </div>
          </div>

          <div className="WIDItem">
            <div className="WIDItemHeader">
              <div className="WIDicon">
                <img src={fullstack} alt="fullstack" />
              </div>
              <div className="WIDDetails">
                <h3>Full-Stack Web Development</h3>
              </div>
            </div>
            <div className="WIDPoints">
              <span>
                Integrating frontend and backend components seamlessly for
                cohesive web applications.
              </span>
              <div>
                <hr />
              </div>
              <span>
                Collaborating across teams to ensure efficient communication
                between client and server.
              </span>
              <div>
                <hr />
              </div>
              <span>
                Troubleshooting end-to-end functionality to deliver bug-free
                user experiences.
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
